import { CardExpiryElement } from '@stripe/react-stripe-js'
import WithPrefillableInput from './WithPrefillableInput'

export default WithPrefillableInput(CardExpiryElement)
